import type { LeftMenuType } from 'redux/reducers/leftSideMenu'

import clearListIcon from 'assets/image/icons/left-side-menu/clear-list.svg'
import { Link } from 'react-router-dom'

import TooltipCustom from '../../../atoms/tooltipCustom'

interface RecentListItem {
	archived?: boolean
	id: string
	name: string
}

interface RecentListProps {
	active: null | number | string
	items?: RecentListItem[]
	label?: string
	linkBuilder: (type: LeftMenuType, id: string, archived?: boolean) => string
	onClick: (item: RecentListItem) => void
	type: LeftMenuType
}

export function RecentList({ active, items, label, linkBuilder, onClick, type }: RecentListProps) {
	if (!items || items.length === 0) return null

	return (
		<>
			<div className='recently-title'>{label}</div>
			<ul>
				{items.map(item => (
					<li
						className={`${active === item.id ? 'active' : ''}`}
						key={item.id}
					>
						<Link
							className='text-list'
							onClick={() => onClick(item)}
							to={linkBuilder(type, item.id, item.archived) || ''}
						>
							<img
								alt='clockIcon'
								className='with-shift'
								src={clearListIcon}
							/>
							<TooltipCustom
								arrow={true}
								title={item.name.length > 24 ? item.name : ''}
							>
								<p
									className={
										item.name.length > 24
											? 'ellipsis'
											: 'left-list-text'
									}
								>
									{item.name}
								</p>
							</TooltipCustom>
						</Link>
					</li>
				))}
			</ul>
		</>
	)
}
